import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

import { postServerUnmountRemoteBackup } from "redux/handlers/serverHandler";

import { useAppDispatch } from "hooks/reduxHook";

const DisableRemoteBackup = ({ id, bucket_id_db }: { id: number; bucket_id_db: number }) => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [openModal, setOpenModal] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [deleteData, setDeleteData] = useState<boolean>(false);

 const handleOpen = () => setOpenModal(true);
 const handleClose = () => setOpenModal(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postServerUnmountRemoteBackup(id, bucket_id_db, deleteData));
  setLoading(false);
  handleClose();
 };

 return (
  <>
   <Tooltip title={intl.formatMessage({ id: "server.disableRemoteBackup" })} placement="top">
    <IconButton onClick={handleOpen}>
     <IconSelector icon="CloudOffIcon" props={{ color: "kxOrange" }} />
    </IconButton>
   </Tooltip>
   <AppModal
    open={openModal}
    close={handleClose}
    title={intl.formatMessage({ id: "server.disableRemoteBackup" })}
    handleClose={handleClose}
    disabled={loading}
    handleConfirm={handleConfirm}>
    <Stack>
     <Typography variant="subtitle2">
      <FormattedMessage id={"server.disableRemoteBackupMessage"} />
     </Typography>
     <FormControlLabel
      control={
       <Checkbox
        checked={deleteData}
        onChange={(e, checked) => {
         setDeleteData(checked);
        }}
       />
      }
      label={intl.formatMessage({ id: "docker.website.removeFolderData" })}
     />
    </Stack>
   </AppModal>
  </>
 );
};

export default DisableRemoteBackup;
